import React from 'react';
import MyTasks from './MyTask';

function EmpPendingTask() {
  return <MyTasks defaultStatus="Pending" />;
}

export default EmpPendingTask;